/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as authRouteRouteImport } from './routes/(auth)/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as AuthenticatedWorkspaceIdRouteRouteImport } from './routes/_authenticated/$workspaceId/route'
import { Route as AuthenticatedWorkspaceIdIndexRouteImport } from './routes/_authenticated/$workspaceId/index'
import { Route as AuthenticatedWorkspaceIdLibraryRouteImport } from './routes/_authenticated/$workspaceId/library'
import { Route as AuthenticatedWorkspaceIdClauseRouteImport } from './routes/_authenticated/$workspaceId/clause'
import { Route as AuthenticatedWorkspaceIdAgentRouteRouteImport } from './routes/_authenticated/$workspaceId/agent/route'
import { Route as AuthenticatedWorkspaceIdPortfolioIndexRouteImport } from './routes/_authenticated/$workspaceId/portfolio/index'
import { Route as AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRouteImport } from './routes/_authenticated/$workspaceId/submissions/$submissionId/route'
import { Route as AuthenticatedWorkspaceIdSubmissionsSubmissionIdIndexRouteImport } from './routes/_authenticated/$workspaceId/submissions/$submissionId/index'
import { Route as AuthenticatedWorkspaceIdComparisonComparisonIdIndexRouteImport } from './routes/_authenticated/$workspaceId/comparison/$comparisonId/index'
import { Route as AuthenticatedWorkspaceIdComparisonComparisonIdTextRouteImport } from './routes/_authenticated/$workspaceId/comparison/$comparisonId/text'
import { Route as AuthenticatedWorkspaceIdComparisonComparisonIdSemanticRouteImport } from './routes/_authenticated/$workspaceId/comparison/$comparisonId/semantic'

const authForgotPasswordLazyRouteImport = createFileRoute(
  '/(auth)/forgot-password',
)()
const authCallbackLazyRouteImport = createFileRoute('/(auth)/callback')()
const AuthenticatedWorkspaceIdPortfolioRouteLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/portfolio',
)()
const AuthenticatedWorkspaceIdSubmissionsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/submissions/',
)()
const AuthenticatedWorkspaceIdDocumentsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/documents/',
)()
const AuthenticatedWorkspaceIdComparisonIndexLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/comparison/',
)()
const AuthenticatedWorkspaceIdAgentIndexLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/agent/',
)()
const AuthenticatedWorkspaceIdPortfolioSubmissionsLazyRouteImport =
  createFileRoute('/_authenticated/$workspaceId/portfolio/submissions')()
const AuthenticatedWorkspaceIdPortfolioClausesLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/portfolio/clauses',
)()
const AuthenticatedWorkspaceIdAgentConversationIdIndexLazyRouteImport =
  createFileRoute('/_authenticated/$workspaceId/agent/$conversationId/')()
const AuthenticatedWorkspaceIdSubmissionsSubmissionIdOverviewLazyRouteImport =
  createFileRoute(
    '/_authenticated/$workspaceId/submissions/$submissionId/overview',
  )()
const AuthenticatedWorkspaceIdSubmissionsSubmissionIdFilesLazyRouteImport =
  createFileRoute(
    '/_authenticated/$workspaceId/submissions/$submissionId/files',
  )()
const AuthenticatedWorkspaceIdSubmissionsSubmissionIdCommentsLazyRouteImport =
  createFileRoute(
    '/_authenticated/$workspaceId/submissions/$submissionId/comments',
  )()
const AuthenticatedWorkspaceIdSubmissionsSubmissionIdRecommendationsIndexLazyRouteImport =
  createFileRoute(
    '/_authenticated/$workspaceId/submissions/$submissionId/recommendations/',
  )()
const AuthenticatedWorkspaceIdSubmissionsSubmissionIdGenerationsIndexLazyRouteImport =
  createFileRoute(
    '/_authenticated/$workspaceId/submissions/$submissionId/generations/',
  )()
const AuthenticatedWorkspaceIdSubmissionsSubmissionIdControlsIndexLazyRouteImport =
  createFileRoute(
    '/_authenticated/$workspaceId/submissions/$submissionId/controls/',
  )()
const AuthenticatedWorkspaceIdSubmissionsSubmissionIdAttributesIndexLazyRouteImport =
  createFileRoute(
    '/_authenticated/$workspaceId/submissions/$submissionId/attributes/',
  )()
const AuthenticatedWorkspaceIdSubmissionsSubmissionIdRecommendationsRecommendationIdLazyRouteImport =
  createFileRoute(
    '/_authenticated/$workspaceId/submissions/$submissionId/recommendations/$recommendationId',
  )()
const AuthenticatedWorkspaceIdSubmissionsSubmissionIdGenerationsGenerationIdLazyRouteImport =
  createFileRoute(
    '/_authenticated/$workspaceId/submissions/$submissionId/generations/$generationId',
  )()
const AuthenticatedWorkspaceIdSubmissionsSubmissionIdControlsControlIdLazyRouteImport =
  createFileRoute(
    '/_authenticated/$workspaceId/submissions/$submissionId/controls/$controlId',
  )()
const AuthenticatedWorkspaceIdSubmissionsSubmissionIdAttributesComponentIdLazyRouteImport =
  createFileRoute(
    '/_authenticated/$workspaceId/submissions/$submissionId/attributes/$componentId',
  )()

const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const authRouteRoute = authRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/index.lazy').then((d) => d.Route),
)
const authForgotPasswordLazyRoute = authForgotPasswordLazyRouteImport
  .update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => authRouteRoute,
  } as any)
  .lazy(() =>
    import('./routes/(auth)/forgot-password.lazy').then((d) => d.Route),
  )
const authCallbackLazyRoute = authCallbackLazyRouteImport
  .update({
    id: '/callback',
    path: '/callback',
    getParentRoute: () => authRouteRoute,
  } as any)
  .lazy(() => import('./routes/(auth)/callback.lazy').then((d) => d.Route))
const authSignInRoute = authSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => authRouteRoute,
} as any)
const AuthenticatedWorkspaceIdRouteRoute =
  AuthenticatedWorkspaceIdRouteRouteImport.update({
    id: '/$workspaceId',
    path: '/$workspaceId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdIndexRoute =
  AuthenticatedWorkspaceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any)
const AuthenticatedWorkspaceIdPortfolioRouteLazyRoute =
  AuthenticatedWorkspaceIdPortfolioRouteLazyRouteImport.update({
    id: '/portfolio',
    path: '/portfolio',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/portfolio/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdLibraryRoute =
  AuthenticatedWorkspaceIdLibraryRouteImport.update({
    id: '/library',
    path: '/library',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/library.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdClauseRoute =
  AuthenticatedWorkspaceIdClauseRouteImport.update({
    id: '/clause',
    path: '/clause',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/clause.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdAgentRouteRoute =
  AuthenticatedWorkspaceIdAgentRouteRouteImport.update({
    id: '/agent',
    path: '/agent',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any)
const AuthenticatedWorkspaceIdSubmissionsIndexLazyRoute =
  AuthenticatedWorkspaceIdSubmissionsIndexLazyRouteImport.update({
    id: '/submissions/',
    path: '/submissions/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/submissions/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdDocumentsIndexLazyRoute =
  AuthenticatedWorkspaceIdDocumentsIndexLazyRouteImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/documents/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdComparisonIndexLazyRoute =
  AuthenticatedWorkspaceIdComparisonIndexLazyRouteImport.update({
    id: '/comparison/',
    path: '/comparison/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/comparison/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdAgentIndexLazyRoute =
  AuthenticatedWorkspaceIdAgentIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspaceIdAgentRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/agent/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdPortfolioIndexRoute =
  AuthenticatedWorkspaceIdPortfolioIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspaceIdPortfolioRouteLazyRoute,
  } as any)
const AuthenticatedWorkspaceIdPortfolioSubmissionsLazyRoute =
  AuthenticatedWorkspaceIdPortfolioSubmissionsLazyRouteImport.update({
    id: '/submissions',
    path: '/submissions',
    getParentRoute: () => AuthenticatedWorkspaceIdPortfolioRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/portfolio/submissions.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdPortfolioClausesLazyRoute =
  AuthenticatedWorkspaceIdPortfolioClausesLazyRouteImport.update({
    id: '/clauses',
    path: '/clauses',
    getParentRoute: () => AuthenticatedWorkspaceIdPortfolioRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/portfolio/clauses.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute =
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRouteImport.update({
    id: '/submissions/$submissionId',
    path: '/submissions/$submissionId',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any)
const AuthenticatedWorkspaceIdAgentConversationIdIndexLazyRoute =
  AuthenticatedWorkspaceIdAgentConversationIdIndexLazyRouteImport.update({
    id: '/$conversationId/',
    path: '/$conversationId/',
    getParentRoute: () => AuthenticatedWorkspaceIdAgentRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/agent/$conversationId/index.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdSubmissionsSubmissionIdIndexRoute =
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute,
  } as any)
const AuthenticatedWorkspaceIdComparisonComparisonIdIndexRoute =
  AuthenticatedWorkspaceIdComparisonComparisonIdIndexRouteImport.update({
    id: '/comparison/$comparisonId/',
    path: '/comparison/$comparisonId/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any)
const AuthenticatedWorkspaceIdSubmissionsSubmissionIdOverviewLazyRoute =
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdOverviewLazyRouteImport.update(
    {
      id: '/overview',
      path: '/overview',
      getParentRoute: () =>
        AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/submissions/$submissionId/overview.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdSubmissionsSubmissionIdFilesLazyRoute =
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdFilesLazyRouteImport.update({
    id: '/files',
    path: '/files',
    getParentRoute: () =>
      AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/submissions/$submissionId/files.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdSubmissionsSubmissionIdCommentsLazyRoute =
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdCommentsLazyRouteImport.update(
    {
      id: '/comments',
      path: '/comments',
      getParentRoute: () =>
        AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/submissions/$submissionId/comments.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdComparisonComparisonIdTextRoute =
  AuthenticatedWorkspaceIdComparisonComparisonIdTextRouteImport.update({
    id: '/comparison/$comparisonId/text',
    path: '/comparison/$comparisonId/text',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/comparison/$comparisonId/text.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdComparisonComparisonIdSemanticRoute =
  AuthenticatedWorkspaceIdComparisonComparisonIdSemanticRouteImport.update({
    id: '/comparison/$comparisonId/semantic',
    path: '/comparison/$comparisonId/semantic',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/comparison/$comparisonId/semantic.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdSubmissionsSubmissionIdRecommendationsIndexLazyRoute =
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdRecommendationsIndexLazyRouteImport.update(
    {
      id: '/recommendations/',
      path: '/recommendations/',
      getParentRoute: () =>
        AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/submissions/$submissionId/recommendations/index.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdSubmissionsSubmissionIdGenerationsIndexLazyRoute =
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdGenerationsIndexLazyRouteImport.update(
    {
      id: '/generations/',
      path: '/generations/',
      getParentRoute: () =>
        AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/submissions/$submissionId/generations/index.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdSubmissionsSubmissionIdControlsIndexLazyRoute =
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdControlsIndexLazyRouteImport.update(
    {
      id: '/controls/',
      path: '/controls/',
      getParentRoute: () =>
        AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/submissions/$submissionId/controls/index.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdSubmissionsSubmissionIdAttributesIndexLazyRoute =
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdAttributesIndexLazyRouteImport.update(
    {
      id: '/attributes/',
      path: '/attributes/',
      getParentRoute: () =>
        AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/submissions/$submissionId/attributes/index.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdSubmissionsSubmissionIdRecommendationsRecommendationIdLazyRoute =
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdRecommendationsRecommendationIdLazyRouteImport.update(
    {
      id: '/recommendations/$recommendationId',
      path: '/recommendations/$recommendationId',
      getParentRoute: () =>
        AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/submissions/$submissionId/recommendations/$recommendationId.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdSubmissionsSubmissionIdGenerationsGenerationIdLazyRoute =
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdGenerationsGenerationIdLazyRouteImport.update(
    {
      id: '/generations/$generationId',
      path: '/generations/$generationId',
      getParentRoute: () =>
        AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/submissions/$submissionId/generations/$generationId.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdSubmissionsSubmissionIdControlsControlIdLazyRoute =
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdControlsControlIdLazyRouteImport.update(
    {
      id: '/controls/$controlId',
      path: '/controls/$controlId',
      getParentRoute: () =>
        AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/submissions/$submissionId/controls/$controlId.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdSubmissionsSubmissionIdAttributesComponentIdLazyRoute =
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdAttributesComponentIdLazyRouteImport.update(
    {
      id: '/attributes/$componentId',
      path: '/attributes/$componentId',
      getParentRoute: () =>
        AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/submissions/$submissionId/attributes/$componentId.lazy'
    ).then((d) => d.Route),
  )

export interface FileRoutesByFullPath {
  '/logout': typeof LogoutRoute
  '/$workspaceId': typeof AuthenticatedWorkspaceIdRouteRouteWithChildren
  '/sign-in': typeof authSignInRoute
  '/callback': typeof authCallbackLazyRoute
  '/forgot-password': typeof authForgotPasswordLazyRoute
  '/': typeof AuthenticatedIndexRoute
  '/$workspaceId/agent': typeof AuthenticatedWorkspaceIdAgentRouteRouteWithChildren
  '/$workspaceId/clause': typeof AuthenticatedWorkspaceIdClauseRoute
  '/$workspaceId/library': typeof AuthenticatedWorkspaceIdLibraryRoute
  '/$workspaceId/portfolio': typeof AuthenticatedWorkspaceIdPortfolioRouteLazyRouteWithChildren
  '/$workspaceId/': typeof AuthenticatedWorkspaceIdIndexRoute
  '/$workspaceId/submissions/$submissionId': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRouteWithChildren
  '/$workspaceId/portfolio/clauses': typeof AuthenticatedWorkspaceIdPortfolioClausesLazyRoute
  '/$workspaceId/portfolio/submissions': typeof AuthenticatedWorkspaceIdPortfolioSubmissionsLazyRoute
  '/$workspaceId/portfolio/': typeof AuthenticatedWorkspaceIdPortfolioIndexRoute
  '/$workspaceId/agent/': typeof AuthenticatedWorkspaceIdAgentIndexLazyRoute
  '/$workspaceId/comparison': typeof AuthenticatedWorkspaceIdComparisonIndexLazyRoute
  '/$workspaceId/documents': typeof AuthenticatedWorkspaceIdDocumentsIndexLazyRoute
  '/$workspaceId/submissions': typeof AuthenticatedWorkspaceIdSubmissionsIndexLazyRoute
  '/$workspaceId/comparison/$comparisonId/semantic': typeof AuthenticatedWorkspaceIdComparisonComparisonIdSemanticRoute
  '/$workspaceId/comparison/$comparisonId/text': typeof AuthenticatedWorkspaceIdComparisonComparisonIdTextRoute
  '/$workspaceId/submissions/$submissionId/comments': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdCommentsLazyRoute
  '/$workspaceId/submissions/$submissionId/files': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdFilesLazyRoute
  '/$workspaceId/submissions/$submissionId/overview': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdOverviewLazyRoute
  '/$workspaceId/comparison/$comparisonId': typeof AuthenticatedWorkspaceIdComparisonComparisonIdIndexRoute
  '/$workspaceId/submissions/$submissionId/': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdIndexRoute
  '/$workspaceId/agent/$conversationId': typeof AuthenticatedWorkspaceIdAgentConversationIdIndexLazyRoute
  '/$workspaceId/submissions/$submissionId/attributes/$componentId': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdAttributesComponentIdLazyRoute
  '/$workspaceId/submissions/$submissionId/controls/$controlId': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdControlsControlIdLazyRoute
  '/$workspaceId/submissions/$submissionId/generations/$generationId': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdGenerationsGenerationIdLazyRoute
  '/$workspaceId/submissions/$submissionId/recommendations/$recommendationId': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdRecommendationsRecommendationIdLazyRoute
  '/$workspaceId/submissions/$submissionId/attributes': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdAttributesIndexLazyRoute
  '/$workspaceId/submissions/$submissionId/controls': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdControlsIndexLazyRoute
  '/$workspaceId/submissions/$submissionId/generations': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdGenerationsIndexLazyRoute
  '/$workspaceId/submissions/$submissionId/recommendations': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdRecommendationsIndexLazyRoute
}
export interface FileRoutesByTo {
  '/logout': typeof LogoutRoute
  '/sign-in': typeof authSignInRoute
  '/callback': typeof authCallbackLazyRoute
  '/forgot-password': typeof authForgotPasswordLazyRoute
  '/': typeof AuthenticatedIndexRoute
  '/$workspaceId/clause': typeof AuthenticatedWorkspaceIdClauseRoute
  '/$workspaceId/library': typeof AuthenticatedWorkspaceIdLibraryRoute
  '/$workspaceId': typeof AuthenticatedWorkspaceIdIndexRoute
  '/$workspaceId/portfolio/clauses': typeof AuthenticatedWorkspaceIdPortfolioClausesLazyRoute
  '/$workspaceId/portfolio/submissions': typeof AuthenticatedWorkspaceIdPortfolioSubmissionsLazyRoute
  '/$workspaceId/portfolio': typeof AuthenticatedWorkspaceIdPortfolioIndexRoute
  '/$workspaceId/agent': typeof AuthenticatedWorkspaceIdAgentIndexLazyRoute
  '/$workspaceId/comparison': typeof AuthenticatedWorkspaceIdComparisonIndexLazyRoute
  '/$workspaceId/documents': typeof AuthenticatedWorkspaceIdDocumentsIndexLazyRoute
  '/$workspaceId/submissions': typeof AuthenticatedWorkspaceIdSubmissionsIndexLazyRoute
  '/$workspaceId/comparison/$comparisonId/semantic': typeof AuthenticatedWorkspaceIdComparisonComparisonIdSemanticRoute
  '/$workspaceId/comparison/$comparisonId/text': typeof AuthenticatedWorkspaceIdComparisonComparisonIdTextRoute
  '/$workspaceId/submissions/$submissionId/comments': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdCommentsLazyRoute
  '/$workspaceId/submissions/$submissionId/files': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdFilesLazyRoute
  '/$workspaceId/submissions/$submissionId/overview': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdOverviewLazyRoute
  '/$workspaceId/comparison/$comparisonId': typeof AuthenticatedWorkspaceIdComparisonComparisonIdIndexRoute
  '/$workspaceId/submissions/$submissionId': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdIndexRoute
  '/$workspaceId/agent/$conversationId': typeof AuthenticatedWorkspaceIdAgentConversationIdIndexLazyRoute
  '/$workspaceId/submissions/$submissionId/attributes/$componentId': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdAttributesComponentIdLazyRoute
  '/$workspaceId/submissions/$submissionId/controls/$controlId': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdControlsControlIdLazyRoute
  '/$workspaceId/submissions/$submissionId/generations/$generationId': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdGenerationsGenerationIdLazyRoute
  '/$workspaceId/submissions/$submissionId/recommendations/$recommendationId': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdRecommendationsRecommendationIdLazyRoute
  '/$workspaceId/submissions/$submissionId/attributes': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdAttributesIndexLazyRoute
  '/$workspaceId/submissions/$submissionId/controls': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdControlsIndexLazyRoute
  '/$workspaceId/submissions/$submissionId/generations': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdGenerationsIndexLazyRoute
  '/$workspaceId/submissions/$submissionId/recommendations': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdRecommendationsIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(auth)': typeof authRouteRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/logout': typeof LogoutRoute
  '/_authenticated/$workspaceId': typeof AuthenticatedWorkspaceIdRouteRouteWithChildren
  '/(auth)/sign-in': typeof authSignInRoute
  '/(auth)/callback': typeof authCallbackLazyRoute
  '/(auth)/forgot-password': typeof authForgotPasswordLazyRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/$workspaceId/agent': typeof AuthenticatedWorkspaceIdAgentRouteRouteWithChildren
  '/_authenticated/$workspaceId/clause': typeof AuthenticatedWorkspaceIdClauseRoute
  '/_authenticated/$workspaceId/library': typeof AuthenticatedWorkspaceIdLibraryRoute
  '/_authenticated/$workspaceId/portfolio': typeof AuthenticatedWorkspaceIdPortfolioRouteLazyRouteWithChildren
  '/_authenticated/$workspaceId/': typeof AuthenticatedWorkspaceIdIndexRoute
  '/_authenticated/$workspaceId/submissions/$submissionId': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRouteWithChildren
  '/_authenticated/$workspaceId/portfolio/clauses': typeof AuthenticatedWorkspaceIdPortfolioClausesLazyRoute
  '/_authenticated/$workspaceId/portfolio/submissions': typeof AuthenticatedWorkspaceIdPortfolioSubmissionsLazyRoute
  '/_authenticated/$workspaceId/portfolio/': typeof AuthenticatedWorkspaceIdPortfolioIndexRoute
  '/_authenticated/$workspaceId/agent/': typeof AuthenticatedWorkspaceIdAgentIndexLazyRoute
  '/_authenticated/$workspaceId/comparison/': typeof AuthenticatedWorkspaceIdComparisonIndexLazyRoute
  '/_authenticated/$workspaceId/documents/': typeof AuthenticatedWorkspaceIdDocumentsIndexLazyRoute
  '/_authenticated/$workspaceId/submissions/': typeof AuthenticatedWorkspaceIdSubmissionsIndexLazyRoute
  '/_authenticated/$workspaceId/comparison/$comparisonId/semantic': typeof AuthenticatedWorkspaceIdComparisonComparisonIdSemanticRoute
  '/_authenticated/$workspaceId/comparison/$comparisonId/text': typeof AuthenticatedWorkspaceIdComparisonComparisonIdTextRoute
  '/_authenticated/$workspaceId/submissions/$submissionId/comments': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdCommentsLazyRoute
  '/_authenticated/$workspaceId/submissions/$submissionId/files': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdFilesLazyRoute
  '/_authenticated/$workspaceId/submissions/$submissionId/overview': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdOverviewLazyRoute
  '/_authenticated/$workspaceId/comparison/$comparisonId/': typeof AuthenticatedWorkspaceIdComparisonComparisonIdIndexRoute
  '/_authenticated/$workspaceId/submissions/$submissionId/': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdIndexRoute
  '/_authenticated/$workspaceId/agent/$conversationId/': typeof AuthenticatedWorkspaceIdAgentConversationIdIndexLazyRoute
  '/_authenticated/$workspaceId/submissions/$submissionId/attributes/$componentId': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdAttributesComponentIdLazyRoute
  '/_authenticated/$workspaceId/submissions/$submissionId/controls/$controlId': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdControlsControlIdLazyRoute
  '/_authenticated/$workspaceId/submissions/$submissionId/generations/$generationId': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdGenerationsGenerationIdLazyRoute
  '/_authenticated/$workspaceId/submissions/$submissionId/recommendations/$recommendationId': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdRecommendationsRecommendationIdLazyRoute
  '/_authenticated/$workspaceId/submissions/$submissionId/attributes/': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdAttributesIndexLazyRoute
  '/_authenticated/$workspaceId/submissions/$submissionId/controls/': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdControlsIndexLazyRoute
  '/_authenticated/$workspaceId/submissions/$submissionId/generations/': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdGenerationsIndexLazyRoute
  '/_authenticated/$workspaceId/submissions/$submissionId/recommendations/': typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdRecommendationsIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/logout'
    | '/$workspaceId'
    | '/sign-in'
    | '/callback'
    | '/forgot-password'
    | '/'
    | '/$workspaceId/agent'
    | '/$workspaceId/clause'
    | '/$workspaceId/library'
    | '/$workspaceId/portfolio'
    | '/$workspaceId/'
    | '/$workspaceId/submissions/$submissionId'
    | '/$workspaceId/portfolio/clauses'
    | '/$workspaceId/portfolio/submissions'
    | '/$workspaceId/portfolio/'
    | '/$workspaceId/agent/'
    | '/$workspaceId/comparison'
    | '/$workspaceId/documents'
    | '/$workspaceId/submissions'
    | '/$workspaceId/comparison/$comparisonId/semantic'
    | '/$workspaceId/comparison/$comparisonId/text'
    | '/$workspaceId/submissions/$submissionId/comments'
    | '/$workspaceId/submissions/$submissionId/files'
    | '/$workspaceId/submissions/$submissionId/overview'
    | '/$workspaceId/comparison/$comparisonId'
    | '/$workspaceId/submissions/$submissionId/'
    | '/$workspaceId/agent/$conversationId'
    | '/$workspaceId/submissions/$submissionId/attributes/$componentId'
    | '/$workspaceId/submissions/$submissionId/controls/$controlId'
    | '/$workspaceId/submissions/$submissionId/generations/$generationId'
    | '/$workspaceId/submissions/$submissionId/recommendations/$recommendationId'
    | '/$workspaceId/submissions/$submissionId/attributes'
    | '/$workspaceId/submissions/$submissionId/controls'
    | '/$workspaceId/submissions/$submissionId/generations'
    | '/$workspaceId/submissions/$submissionId/recommendations'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/logout'
    | '/sign-in'
    | '/callback'
    | '/forgot-password'
    | '/'
    | '/$workspaceId/clause'
    | '/$workspaceId/library'
    | '/$workspaceId'
    | '/$workspaceId/portfolio/clauses'
    | '/$workspaceId/portfolio/submissions'
    | '/$workspaceId/portfolio'
    | '/$workspaceId/agent'
    | '/$workspaceId/comparison'
    | '/$workspaceId/documents'
    | '/$workspaceId/submissions'
    | '/$workspaceId/comparison/$comparisonId/semantic'
    | '/$workspaceId/comparison/$comparisonId/text'
    | '/$workspaceId/submissions/$submissionId/comments'
    | '/$workspaceId/submissions/$submissionId/files'
    | '/$workspaceId/submissions/$submissionId/overview'
    | '/$workspaceId/comparison/$comparisonId'
    | '/$workspaceId/submissions/$submissionId'
    | '/$workspaceId/agent/$conversationId'
    | '/$workspaceId/submissions/$submissionId/attributes/$componentId'
    | '/$workspaceId/submissions/$submissionId/controls/$controlId'
    | '/$workspaceId/submissions/$submissionId/generations/$generationId'
    | '/$workspaceId/submissions/$submissionId/recommendations/$recommendationId'
    | '/$workspaceId/submissions/$submissionId/attributes'
    | '/$workspaceId/submissions/$submissionId/controls'
    | '/$workspaceId/submissions/$submissionId/generations'
    | '/$workspaceId/submissions/$submissionId/recommendations'
  id:
    | '__root__'
    | '/(auth)'
    | '/_authenticated'
    | '/logout'
    | '/_authenticated/$workspaceId'
    | '/(auth)/sign-in'
    | '/(auth)/callback'
    | '/(auth)/forgot-password'
    | '/_authenticated/'
    | '/_authenticated/$workspaceId/agent'
    | '/_authenticated/$workspaceId/clause'
    | '/_authenticated/$workspaceId/library'
    | '/_authenticated/$workspaceId/portfolio'
    | '/_authenticated/$workspaceId/'
    | '/_authenticated/$workspaceId/submissions/$submissionId'
    | '/_authenticated/$workspaceId/portfolio/clauses'
    | '/_authenticated/$workspaceId/portfolio/submissions'
    | '/_authenticated/$workspaceId/portfolio/'
    | '/_authenticated/$workspaceId/agent/'
    | '/_authenticated/$workspaceId/comparison/'
    | '/_authenticated/$workspaceId/documents/'
    | '/_authenticated/$workspaceId/submissions/'
    | '/_authenticated/$workspaceId/comparison/$comparisonId/semantic'
    | '/_authenticated/$workspaceId/comparison/$comparisonId/text'
    | '/_authenticated/$workspaceId/submissions/$submissionId/comments'
    | '/_authenticated/$workspaceId/submissions/$submissionId/files'
    | '/_authenticated/$workspaceId/submissions/$submissionId/overview'
    | '/_authenticated/$workspaceId/comparison/$comparisonId/'
    | '/_authenticated/$workspaceId/submissions/$submissionId/'
    | '/_authenticated/$workspaceId/agent/$conversationId/'
    | '/_authenticated/$workspaceId/submissions/$submissionId/attributes/$componentId'
    | '/_authenticated/$workspaceId/submissions/$submissionId/controls/$controlId'
    | '/_authenticated/$workspaceId/submissions/$submissionId/generations/$generationId'
    | '/_authenticated/$workspaceId/submissions/$submissionId/recommendations/$recommendationId'
    | '/_authenticated/$workspaceId/submissions/$submissionId/attributes/'
    | '/_authenticated/$workspaceId/submissions/$submissionId/controls/'
    | '/_authenticated/$workspaceId/submissions/$submissionId/generations/'
    | '/_authenticated/$workspaceId/submissions/$submissionId/recommendations/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  authRouteRoute: typeof authRouteRouteWithChildren
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  LogoutRoute: typeof LogoutRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)': {
      id: '/(auth)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof authRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordLazyRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/callback': {
      id: '/(auth)/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof authCallbackLazyRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/_authenticated/$workspaceId': {
      id: '/_authenticated/$workspaceId'
      path: '/$workspaceId'
      fullPath: '/$workspaceId'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/$workspaceId/': {
      id: '/_authenticated/$workspaceId/'
      path: '/'
      fullPath: '/$workspaceId/'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdIndexRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/portfolio': {
      id: '/_authenticated/$workspaceId/portfolio'
      path: '/portfolio'
      fullPath: '/$workspaceId/portfolio'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdPortfolioRouteLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/library': {
      id: '/_authenticated/$workspaceId/library'
      path: '/library'
      fullPath: '/$workspaceId/library'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdLibraryRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/clause': {
      id: '/_authenticated/$workspaceId/clause'
      path: '/clause'
      fullPath: '/$workspaceId/clause'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdClauseRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/agent': {
      id: '/_authenticated/$workspaceId/agent'
      path: '/agent'
      fullPath: '/$workspaceId/agent'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdAgentRouteRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/submissions/': {
      id: '/_authenticated/$workspaceId/submissions/'
      path: '/submissions'
      fullPath: '/$workspaceId/submissions'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSubmissionsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/documents/': {
      id: '/_authenticated/$workspaceId/documents/'
      path: '/documents'
      fullPath: '/$workspaceId/documents'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdDocumentsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/comparison/': {
      id: '/_authenticated/$workspaceId/comparison/'
      path: '/comparison'
      fullPath: '/$workspaceId/comparison'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdComparisonIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/agent/': {
      id: '/_authenticated/$workspaceId/agent/'
      path: '/'
      fullPath: '/$workspaceId/agent/'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdAgentIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdAgentRouteRoute
    }
    '/_authenticated/$workspaceId/portfolio/': {
      id: '/_authenticated/$workspaceId/portfolio/'
      path: '/'
      fullPath: '/$workspaceId/portfolio/'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdPortfolioIndexRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdPortfolioRouteLazyRoute
    }
    '/_authenticated/$workspaceId/portfolio/submissions': {
      id: '/_authenticated/$workspaceId/portfolio/submissions'
      path: '/submissions'
      fullPath: '/$workspaceId/portfolio/submissions'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdPortfolioSubmissionsLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdPortfolioRouteLazyRoute
    }
    '/_authenticated/$workspaceId/portfolio/clauses': {
      id: '/_authenticated/$workspaceId/portfolio/clauses'
      path: '/clauses'
      fullPath: '/$workspaceId/portfolio/clauses'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdPortfolioClausesLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdPortfolioRouteLazyRoute
    }
    '/_authenticated/$workspaceId/submissions/$submissionId': {
      id: '/_authenticated/$workspaceId/submissions/$submissionId'
      path: '/submissions/$submissionId'
      fullPath: '/$workspaceId/submissions/$submissionId'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/agent/$conversationId/': {
      id: '/_authenticated/$workspaceId/agent/$conversationId/'
      path: '/$conversationId'
      fullPath: '/$workspaceId/agent/$conversationId'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdAgentConversationIdIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdAgentRouteRoute
    }
    '/_authenticated/$workspaceId/submissions/$submissionId/': {
      id: '/_authenticated/$workspaceId/submissions/$submissionId/'
      path: '/'
      fullPath: '/$workspaceId/submissions/$submissionId/'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdIndexRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute
    }
    '/_authenticated/$workspaceId/comparison/$comparisonId/': {
      id: '/_authenticated/$workspaceId/comparison/$comparisonId/'
      path: '/comparison/$comparisonId'
      fullPath: '/$workspaceId/comparison/$comparisonId'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdComparisonComparisonIdIndexRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/submissions/$submissionId/overview': {
      id: '/_authenticated/$workspaceId/submissions/$submissionId/overview'
      path: '/overview'
      fullPath: '/$workspaceId/submissions/$submissionId/overview'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdOverviewLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute
    }
    '/_authenticated/$workspaceId/submissions/$submissionId/files': {
      id: '/_authenticated/$workspaceId/submissions/$submissionId/files'
      path: '/files'
      fullPath: '/$workspaceId/submissions/$submissionId/files'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdFilesLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute
    }
    '/_authenticated/$workspaceId/submissions/$submissionId/comments': {
      id: '/_authenticated/$workspaceId/submissions/$submissionId/comments'
      path: '/comments'
      fullPath: '/$workspaceId/submissions/$submissionId/comments'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdCommentsLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute
    }
    '/_authenticated/$workspaceId/comparison/$comparisonId/text': {
      id: '/_authenticated/$workspaceId/comparison/$comparisonId/text'
      path: '/comparison/$comparisonId/text'
      fullPath: '/$workspaceId/comparison/$comparisonId/text'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdComparisonComparisonIdTextRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/comparison/$comparisonId/semantic': {
      id: '/_authenticated/$workspaceId/comparison/$comparisonId/semantic'
      path: '/comparison/$comparisonId/semantic'
      fullPath: '/$workspaceId/comparison/$comparisonId/semantic'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdComparisonComparisonIdSemanticRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/submissions/$submissionId/recommendations/': {
      id: '/_authenticated/$workspaceId/submissions/$submissionId/recommendations/'
      path: '/recommendations'
      fullPath: '/$workspaceId/submissions/$submissionId/recommendations'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdRecommendationsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute
    }
    '/_authenticated/$workspaceId/submissions/$submissionId/generations/': {
      id: '/_authenticated/$workspaceId/submissions/$submissionId/generations/'
      path: '/generations'
      fullPath: '/$workspaceId/submissions/$submissionId/generations'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdGenerationsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute
    }
    '/_authenticated/$workspaceId/submissions/$submissionId/controls/': {
      id: '/_authenticated/$workspaceId/submissions/$submissionId/controls/'
      path: '/controls'
      fullPath: '/$workspaceId/submissions/$submissionId/controls'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdControlsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute
    }
    '/_authenticated/$workspaceId/submissions/$submissionId/attributes/': {
      id: '/_authenticated/$workspaceId/submissions/$submissionId/attributes/'
      path: '/attributes'
      fullPath: '/$workspaceId/submissions/$submissionId/attributes'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdAttributesIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute
    }
    '/_authenticated/$workspaceId/submissions/$submissionId/recommendations/$recommendationId': {
      id: '/_authenticated/$workspaceId/submissions/$submissionId/recommendations/$recommendationId'
      path: '/recommendations/$recommendationId'
      fullPath: '/$workspaceId/submissions/$submissionId/recommendations/$recommendationId'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdRecommendationsRecommendationIdLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute
    }
    '/_authenticated/$workspaceId/submissions/$submissionId/generations/$generationId': {
      id: '/_authenticated/$workspaceId/submissions/$submissionId/generations/$generationId'
      path: '/generations/$generationId'
      fullPath: '/$workspaceId/submissions/$submissionId/generations/$generationId'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdGenerationsGenerationIdLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute
    }
    '/_authenticated/$workspaceId/submissions/$submissionId/controls/$controlId': {
      id: '/_authenticated/$workspaceId/submissions/$submissionId/controls/$controlId'
      path: '/controls/$controlId'
      fullPath: '/$workspaceId/submissions/$submissionId/controls/$controlId'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdControlsControlIdLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute
    }
    '/_authenticated/$workspaceId/submissions/$submissionId/attributes/$componentId': {
      id: '/_authenticated/$workspaceId/submissions/$submissionId/attributes/$componentId'
      path: '/attributes/$componentId'
      fullPath: '/$workspaceId/submissions/$submissionId/attributes/$componentId'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdAttributesComponentIdLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute
    }
  }
}

interface authRouteRouteChildren {
  authSignInRoute: typeof authSignInRoute
  authCallbackLazyRoute: typeof authCallbackLazyRoute
  authForgotPasswordLazyRoute: typeof authForgotPasswordLazyRoute
}

const authRouteRouteChildren: authRouteRouteChildren = {
  authSignInRoute: authSignInRoute,
  authCallbackLazyRoute: authCallbackLazyRoute,
  authForgotPasswordLazyRoute: authForgotPasswordLazyRoute,
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(
  authRouteRouteChildren,
)

interface AuthenticatedWorkspaceIdAgentRouteRouteChildren {
  AuthenticatedWorkspaceIdAgentIndexLazyRoute: typeof AuthenticatedWorkspaceIdAgentIndexLazyRoute
  AuthenticatedWorkspaceIdAgentConversationIdIndexLazyRoute: typeof AuthenticatedWorkspaceIdAgentConversationIdIndexLazyRoute
}

const AuthenticatedWorkspaceIdAgentRouteRouteChildren: AuthenticatedWorkspaceIdAgentRouteRouteChildren =
  {
    AuthenticatedWorkspaceIdAgentIndexLazyRoute:
      AuthenticatedWorkspaceIdAgentIndexLazyRoute,
    AuthenticatedWorkspaceIdAgentConversationIdIndexLazyRoute:
      AuthenticatedWorkspaceIdAgentConversationIdIndexLazyRoute,
  }

const AuthenticatedWorkspaceIdAgentRouteRouteWithChildren =
  AuthenticatedWorkspaceIdAgentRouteRoute._addFileChildren(
    AuthenticatedWorkspaceIdAgentRouteRouteChildren,
  )

interface AuthenticatedWorkspaceIdPortfolioRouteLazyRouteChildren {
  AuthenticatedWorkspaceIdPortfolioClausesLazyRoute: typeof AuthenticatedWorkspaceIdPortfolioClausesLazyRoute
  AuthenticatedWorkspaceIdPortfolioSubmissionsLazyRoute: typeof AuthenticatedWorkspaceIdPortfolioSubmissionsLazyRoute
  AuthenticatedWorkspaceIdPortfolioIndexRoute: typeof AuthenticatedWorkspaceIdPortfolioIndexRoute
}

const AuthenticatedWorkspaceIdPortfolioRouteLazyRouteChildren: AuthenticatedWorkspaceIdPortfolioRouteLazyRouteChildren =
  {
    AuthenticatedWorkspaceIdPortfolioClausesLazyRoute:
      AuthenticatedWorkspaceIdPortfolioClausesLazyRoute,
    AuthenticatedWorkspaceIdPortfolioSubmissionsLazyRoute:
      AuthenticatedWorkspaceIdPortfolioSubmissionsLazyRoute,
    AuthenticatedWorkspaceIdPortfolioIndexRoute:
      AuthenticatedWorkspaceIdPortfolioIndexRoute,
  }

const AuthenticatedWorkspaceIdPortfolioRouteLazyRouteWithChildren =
  AuthenticatedWorkspaceIdPortfolioRouteLazyRoute._addFileChildren(
    AuthenticatedWorkspaceIdPortfolioRouteLazyRouteChildren,
  )

interface AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRouteChildren {
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdCommentsLazyRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdCommentsLazyRoute
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdFilesLazyRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdFilesLazyRoute
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdOverviewLazyRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdOverviewLazyRoute
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdIndexRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdIndexRoute
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdAttributesComponentIdLazyRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdAttributesComponentIdLazyRoute
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdControlsControlIdLazyRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdControlsControlIdLazyRoute
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdGenerationsGenerationIdLazyRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdGenerationsGenerationIdLazyRoute
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdRecommendationsRecommendationIdLazyRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdRecommendationsRecommendationIdLazyRoute
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdAttributesIndexLazyRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdAttributesIndexLazyRoute
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdControlsIndexLazyRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdControlsIndexLazyRoute
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdGenerationsIndexLazyRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdGenerationsIndexLazyRoute
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdRecommendationsIndexLazyRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdRecommendationsIndexLazyRoute
}

const AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRouteChildren: AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRouteChildren =
  {
    AuthenticatedWorkspaceIdSubmissionsSubmissionIdCommentsLazyRoute:
      AuthenticatedWorkspaceIdSubmissionsSubmissionIdCommentsLazyRoute,
    AuthenticatedWorkspaceIdSubmissionsSubmissionIdFilesLazyRoute:
      AuthenticatedWorkspaceIdSubmissionsSubmissionIdFilesLazyRoute,
    AuthenticatedWorkspaceIdSubmissionsSubmissionIdOverviewLazyRoute:
      AuthenticatedWorkspaceIdSubmissionsSubmissionIdOverviewLazyRoute,
    AuthenticatedWorkspaceIdSubmissionsSubmissionIdIndexRoute:
      AuthenticatedWorkspaceIdSubmissionsSubmissionIdIndexRoute,
    AuthenticatedWorkspaceIdSubmissionsSubmissionIdAttributesComponentIdLazyRoute:
      AuthenticatedWorkspaceIdSubmissionsSubmissionIdAttributesComponentIdLazyRoute,
    AuthenticatedWorkspaceIdSubmissionsSubmissionIdControlsControlIdLazyRoute:
      AuthenticatedWorkspaceIdSubmissionsSubmissionIdControlsControlIdLazyRoute,
    AuthenticatedWorkspaceIdSubmissionsSubmissionIdGenerationsGenerationIdLazyRoute:
      AuthenticatedWorkspaceIdSubmissionsSubmissionIdGenerationsGenerationIdLazyRoute,
    AuthenticatedWorkspaceIdSubmissionsSubmissionIdRecommendationsRecommendationIdLazyRoute:
      AuthenticatedWorkspaceIdSubmissionsSubmissionIdRecommendationsRecommendationIdLazyRoute,
    AuthenticatedWorkspaceIdSubmissionsSubmissionIdAttributesIndexLazyRoute:
      AuthenticatedWorkspaceIdSubmissionsSubmissionIdAttributesIndexLazyRoute,
    AuthenticatedWorkspaceIdSubmissionsSubmissionIdControlsIndexLazyRoute:
      AuthenticatedWorkspaceIdSubmissionsSubmissionIdControlsIndexLazyRoute,
    AuthenticatedWorkspaceIdSubmissionsSubmissionIdGenerationsIndexLazyRoute:
      AuthenticatedWorkspaceIdSubmissionsSubmissionIdGenerationsIndexLazyRoute,
    AuthenticatedWorkspaceIdSubmissionsSubmissionIdRecommendationsIndexLazyRoute:
      AuthenticatedWorkspaceIdSubmissionsSubmissionIdRecommendationsIndexLazyRoute,
  }

const AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRouteWithChildren =
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute._addFileChildren(
    AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRouteChildren,
  )

interface AuthenticatedWorkspaceIdRouteRouteChildren {
  AuthenticatedWorkspaceIdAgentRouteRoute: typeof AuthenticatedWorkspaceIdAgentRouteRouteWithChildren
  AuthenticatedWorkspaceIdClauseRoute: typeof AuthenticatedWorkspaceIdClauseRoute
  AuthenticatedWorkspaceIdLibraryRoute: typeof AuthenticatedWorkspaceIdLibraryRoute
  AuthenticatedWorkspaceIdPortfolioRouteLazyRoute: typeof AuthenticatedWorkspaceIdPortfolioRouteLazyRouteWithChildren
  AuthenticatedWorkspaceIdIndexRoute: typeof AuthenticatedWorkspaceIdIndexRoute
  AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute: typeof AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRouteWithChildren
  AuthenticatedWorkspaceIdComparisonIndexLazyRoute: typeof AuthenticatedWorkspaceIdComparisonIndexLazyRoute
  AuthenticatedWorkspaceIdDocumentsIndexLazyRoute: typeof AuthenticatedWorkspaceIdDocumentsIndexLazyRoute
  AuthenticatedWorkspaceIdSubmissionsIndexLazyRoute: typeof AuthenticatedWorkspaceIdSubmissionsIndexLazyRoute
  AuthenticatedWorkspaceIdComparisonComparisonIdSemanticRoute: typeof AuthenticatedWorkspaceIdComparisonComparisonIdSemanticRoute
  AuthenticatedWorkspaceIdComparisonComparisonIdTextRoute: typeof AuthenticatedWorkspaceIdComparisonComparisonIdTextRoute
  AuthenticatedWorkspaceIdComparisonComparisonIdIndexRoute: typeof AuthenticatedWorkspaceIdComparisonComparisonIdIndexRoute
}

const AuthenticatedWorkspaceIdRouteRouteChildren: AuthenticatedWorkspaceIdRouteRouteChildren =
  {
    AuthenticatedWorkspaceIdAgentRouteRoute:
      AuthenticatedWorkspaceIdAgentRouteRouteWithChildren,
    AuthenticatedWorkspaceIdClauseRoute: AuthenticatedWorkspaceIdClauseRoute,
    AuthenticatedWorkspaceIdLibraryRoute: AuthenticatedWorkspaceIdLibraryRoute,
    AuthenticatedWorkspaceIdPortfolioRouteLazyRoute:
      AuthenticatedWorkspaceIdPortfolioRouteLazyRouteWithChildren,
    AuthenticatedWorkspaceIdIndexRoute: AuthenticatedWorkspaceIdIndexRoute,
    AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRoute:
      AuthenticatedWorkspaceIdSubmissionsSubmissionIdRouteRouteWithChildren,
    AuthenticatedWorkspaceIdComparisonIndexLazyRoute:
      AuthenticatedWorkspaceIdComparisonIndexLazyRoute,
    AuthenticatedWorkspaceIdDocumentsIndexLazyRoute:
      AuthenticatedWorkspaceIdDocumentsIndexLazyRoute,
    AuthenticatedWorkspaceIdSubmissionsIndexLazyRoute:
      AuthenticatedWorkspaceIdSubmissionsIndexLazyRoute,
    AuthenticatedWorkspaceIdComparisonComparisonIdSemanticRoute:
      AuthenticatedWorkspaceIdComparisonComparisonIdSemanticRoute,
    AuthenticatedWorkspaceIdComparisonComparisonIdTextRoute:
      AuthenticatedWorkspaceIdComparisonComparisonIdTextRoute,
    AuthenticatedWorkspaceIdComparisonComparisonIdIndexRoute:
      AuthenticatedWorkspaceIdComparisonComparisonIdIndexRoute,
  }

const AuthenticatedWorkspaceIdRouteRouteWithChildren =
  AuthenticatedWorkspaceIdRouteRoute._addFileChildren(
    AuthenticatedWorkspaceIdRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedWorkspaceIdRouteRoute: typeof AuthenticatedWorkspaceIdRouteRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedWorkspaceIdRouteRoute:
    AuthenticatedWorkspaceIdRouteRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  authRouteRoute: authRouteRouteWithChildren,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  LogoutRoute: LogoutRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
